import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { Globe, Facebook, Instagram, Twitter, Linkedin, Youtube, Phone, Save } from 'lucide-react';

const SocialLinksTab = ({ authAxios }) => {
  const [socialLinks, setSocialLinks] = useState({
    facebook: '', instagram: '', twitter: '', linkedin: '', whatsapp: '', youtube: ''
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await authAxios.get('/admin/settings');
        if (response.data.social_links) setSocialLinks(response.data.social_links);
      } catch (error) {
        console.error('Failed to fetch social links:', error);
      }
    };
    fetch();
  }, [authAxios]);

  const handleSave = async () => {
    setSaving(true);
    try {
      await authAxios.put('/admin/social-links', socialLinks);
      toast.success('Social links saved successfully!');
    } catch (error) {
      toast.error('Failed to save social links');
    } finally {
      setSaving(false);
    }
  };

  const socials = [
    { key: 'facebook', icon: Facebook, label: 'Facebook', placeholder: 'https://facebook.com/...' },
    { key: 'instagram', icon: Instagram, label: 'Instagram', placeholder: 'https://instagram.com/...' },
    { key: 'twitter', icon: Twitter, label: 'X (Twitter)', placeholder: 'https://x.com/...' },
    { key: 'linkedin', icon: Linkedin, label: 'LinkedIn', placeholder: 'https://linkedin.com/company/...' },
    { key: 'youtube', icon: Youtube, label: 'YouTube', placeholder: 'https://youtube.com/@...' },
    { key: 'whatsapp', icon: Phone, label: 'WhatsApp', placeholder: 'https://wa.me/...' },
  ];

  return (
    <div className="max-w-2xl space-y-6" data-testid="social-links-tab">
      <div className="bg-[#111111] border border-white/5 p-6">
        <h2 className="font-mono font-bold mb-6 flex items-center gap-2">
          <Globe className="w-5 h-5 text-[#D4AF37]" />
          Social Media Links
        </h2>
        <div className="space-y-4">
          {socials.map(social => (
            <div key={social.key}>
              <label className="text-white/50 text-xs font-mono uppercase block mb-2">{social.label}</label>
              <div className="relative">
                <social.icon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-white/30" />
                <input type="url" value={socialLinks[social.key]} onChange={(e) => setSocialLinks({...socialLinks, [social.key]: e.target.value})} placeholder={social.placeholder} className="w-full bg-[#0A0A0A] border border-white/10 pl-10 pr-4 py-3 font-mono text-sm focus:border-[#D4AF37] outline-none" />
              </div>
            </div>
          ))}
          <button onClick={handleSave} disabled={saving} data-testid="save-social-links" className="flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-black font-mono text-sm hover:bg-[#D4AF37]/90 transition-colors disabled:opacity-50">
            <Save className="w-4 h-4" />{saving ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SocialLinksTab;
